export function ConnectGuideIos() {
  return (
    <svg viewBox="0 0 240 320" xmlns="http://www.w3.org/2000/svg" className="w-full max-w-xs mx-auto block" aria-hidden="true">
      {/* Phone frame */}
      <rect x="10" y="10" width="220" height="300" rx="20" ry="20" fill="#1c1c1e" />
      <rect x="18" y="22" width="204" height="276" rx="14" ry="14" fill="#f2f2f7" />
      {/* Title bar */}
      <rect x="18" y="22" width="204" height="64" rx="14" fill="#ffffff" />
      <rect x="18" y="50" width="204" height="36" fill="#ffffff" />
      <text x="120" y="73" textAnchor="middle" fontSize="13" fontWeight="600" fill="#000000">WLAN</text>
      <text x="30" y="73" fontSize="13" fill="#007aff">‹ Einst.</text>
      {/* WLAN toggle ON */}
      <rect x="18" y="86" width="204" height="40" fill="#ffffff" />
      <text x="30" y="111" fontSize="12" fill="#000000">WLAN</text>
      <rect x="180" y="95" width="34" height="20" rx="10" fill="#34c759" />
      <circle cx="203" cy="105" r="9" fill="#ffffff" />
      <line x1="18" y1="126" x2="222" y2="126" stroke="#c6c6c8" strokeWidth="0.5" />
      {/* Section header */}
      <rect x="18" y="126" width="204" height="22" fill="#f2f2f7" />
      <text x="30" y="141" fontSize="10" fill="#6d6d72">MEINE NETZWERKE</text>
      {/* Network rows */}
      <rect x="18" y="148" width="204" height="36" fill="#ffffff" />
      <text x="30" y="171" fontSize="12" fill="#000000">Dein-WLAN</text>
      <line x1="18" y1="184" x2="222" y2="184" stroke="#c6c6c8" strokeWidth="0.5" />
      <rect x="18" y="184" width="204" height="36" fill="#ffffff" />
      <text x="30" y="207" fontSize="12" fill="#000000">Dein-WLAN-5G</text>
      <line x1="18" y1="220" x2="222" y2="220" stroke="#c6c6c8" strokeWidth="0.5" />
      {/* Tap arrow highlight */}
      <rect x="18" y="148" width="204" height="36" fill="#007aff" opacity="0.12" />
      <polygon points="228,166 240,159 240,173" fill="#34c759" />
      <text x="120" y="260" textAnchor="middle" fontSize="10" fill="#6d6d72">Netzwerk antippen</text>
      <text x="120" y="275" textAnchor="middle" fontSize="10" fill="#6d6d72">→ Passwort eingeben</text>
    </svg>
  );
}
